// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"64aababc","685":"21b2fc2a","814":"9cc070cc","840":"88883b5d"}[chunkId] + ".chunk.js";
};